import { motion } from "framer-motion";

const EASE = [0.25, 0.6, 0.3, 1];

export const FadeUp = ({ children, delay = 0, className = "", y = 20 }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-40px" }}
        transition={{ duration: 0.6, delay, ease: EASE }}
        className={className}
    >
        {children}
    </motion.div>
);

export const FadeIn = ({ children, delay = 0, className = "" }) => (
    <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.7, delay, ease: "easeOut" }}
        className={className}
    >
        {children}
    </motion.div>
);

export const Stagger = ({ children, className = "", delay = 0 }) => (
    <motion.div
        className={className}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-40px" }}
        variants={{
            hidden: {},
            show: { transition: { staggerChildren: 0.08, delayChildren: delay } },
        }}
    >
        {children}
    </motion.div>
);

export const StaggerItem = ({ children, className = "" }) => (
    <motion.div
        className={className}
        variants={{
            hidden: { opacity: 0, y: 18 },
            show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: EASE } },
        }}
    >
        {children}
    </motion.div>
);
